import React from "react";
import {EditAvailableFundsModal} from "../../../client/EditAvailableFundsModal";
import {TYPE_CAMPAIGN, TYPE_CAMPAIGNS_CONFIGURATION} from "../DashboardRow";
import {DashboardCell} from "./base/DashboardCell";

export class DashboardAvailableFundsCell extends DashboardCell {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            formattedValue: this.props.formattedValue
        };
        this.handleAvailableFundsModified = this.handleAvailableFundsModified.bind(this);
    }

    handleAvailableFundsModified(data) {
        this.setState({
            value: data.AVAILABLE_FUNDS_COLUMN.value,
            formattedValue: data.AVAILABLE_FUNDS_COLUMN.formatted_value
        });
        this.props.onAvailableFundsUpdated(data)
    }

    render() {
        return (
            <td className={`single-editable-data ${this.processingCssClasses()}`}>
                {this.renderCellContent()}
            </td>
        )
    }

    renderCellContent() {
        if (this.props.rowType === TYPE_CAMPAIGN || this.props.rowType === TYPE_CAMPAIGNS_CONFIGURATION)
            return null;

        return <div className="bu-cell editable">
            <div className="budget-value">{this.state.formattedValue}</div>
            {this.props.readOnly
                ? <div style={{minWidth:"25px"}}></div>
                : <EditAvailableFundsModal onFormSubmitted={this.handleAvailableFundsModified}
                                           businessUnitId={this.props.businessUnitId}
                                           value={this.props.value}
                                           clickOutsideDontCloseModal={true}
                  />}
        </div>;
    }
}
